module.exports = __webpack_public_path__ + "media/ApplicantSummaryWeb.911bbd4d.pdf";